import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {MotCle} from '../../../../class/api/MotCle';
import {TranslationService} from '../../../services/translation.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';

import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-edit-motcles',
    templateUrl: './modal-edit-motcles.component.html',
    styleUrls: ['./modal-edit-motcles.component.scss'],
    imports: [CdkScrollable, MatDialogContent, FormsModule, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalEditMotClesComponent implements OnInit, OnDestroy {
    data = inject<{
    motCle?: MotCle;
    listMotCle?: MotCle[];
}>(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<ModalEditMotClesComponent>>(MatDialogRef);
    translation = inject(TranslationService);


    private subscriptions: Subscription[] = [];

    public motCleFr = '';
    public motCleEn = '';
    public present = false;

    constructor() {
        const data = this.data;

        if(this.data.motCle) {
            this.motCleFr = this.getMotCleTrans(data.motCle, 'fr');
            this.motCleEn = this.getMotCleTrans(data.motCle, 'en');
        }
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(item => item.unsubscribe());
    }

    public noPonctuation(value) {
        return value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ0-9 ]+/g, '');
    }

    public isInList() {
        let inList = false;
        this.data.listMotCle.forEach(motcle => {
            if(this.data.motCle?.id !== motcle.id && (this.translation.getTranslation(motcle, 'fr')?.label == this.motCleFr || this.translation.getTranslation(motcle, 'en')?.label == this.motCleEn)) {
                inList = true;
            }
        });
        this.present = inList;
    }

    private getMotCleTrans(motCle: MotCle, lang: string): string {
        if(motCle.translations !== null && motCle.translations !== undefined)
        {
            const translated = this.translation.getTranslation(motCle, lang);
            if(translated !== null && translated !== undefined) {
                return translated.label;
            }
        }
        return '';
    }
}
